export class deviationReportPath {
    Id: number;
    DeviationId: number;
    GeneratedReportPath: string;
}